export function toEther(wei: string, precision: number): string {
  const amt = wei.padStart(19, '0')
  const decimal = parseFloat('.' + amt.slice(amt.length - 18))
  const roundedDecimal =
    Math.round(decimal * Math.pow(10, precision)) / Math.pow(10, precision)
  return amt.slice(0, amt.length - 18) + roundedDecimal.toString().slice(1)
}
